const getResizedImg = (str) => {
  const img = str.split('.')
  const format = img.pop().toLowerCase()
  return `${img.join('.')}-700px.${format}`
}

export { getResizedImg }
